/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import styles from './SystemsOverview.module.css';
import { useSelector } from 'react-redux';
import MetricsBar from './MetricsBar';
import { useHistory } from 'react-router-dom';
import { useLastMetrics } from '../../hooks/useLastMetrics';

export default function SystemCard({ systemOverview }) {
  const history = useHistory();
  let systemDetails = useSelector(
    (state) => state.bessReducer.details[systemOverview.id]
  );
  const { lastMetrics, timeSinceLastReading } = useLastMetrics(
    systemOverview.id
  );

  const handleSystemClicked = () => {
    history.push(`/system_details/${systemDetails.id}`);
  };

  return (
    <div
      id={systemOverview.id}
      className={styles.bess}
      onClick={handleSystemClicked}
      data-testid={systemOverview.name}
    >
      <div>
        <h3>{systemOverview.name}</h3>
        <p className={styles.location}>{systemOverview.location}</p>
      </div>
      {lastMetrics && (
        <MetricsBar
          metrics={lastMetrics}
          timeSinceLastReading={timeSinceLastReading}
        />
      )}
    </div>
  );
}
